export const environment = {
  production: true,
  apiUrl: 'http://api.shinymaskr.work:28300/',
  cloudFlareUrl: 'http://static.shinymaskr.work/',
  eventViewerUrl: 'http://static.shinymaskr.work/',
};
